

// export const baseUrl=window.location.protocol+"//"+window.location.hostname;
// export const  baseUrl2=window.location.protocol+"//"+window.location.hostname;

export const baseUrl="https://api.imbeiyu.com"
export const  baseUrl2="https://api.imbeiyu.com"



// export const  baseUrl="http://47.94.171.99:59661"

// export const  baseUrl2="http://47.94.171.99:59662"

// export const  baseUrl="https://test.ayc666.cn"

// export const  baseUrl2="https://test.ayc666.cn"


// WEBPACK FOOTER //
// ./src/api/config.js